module.exports = __webpack_public_path__ + "img/generica_generica.6cd8b516.svg";